<template>
  <div class="d-flex flex-column justify-content-center align-items-center col-md-12 router-view-report-background">
    <div class="col-md-12 px-0">
      <report-filters 
        :creators="creators"
        :services="services"
        @submit="submit"    
        @update-filter="updateFilter"
      />
      <presentation 
        :totals="!results.totals ? {} : results.totals"
      />
    </div>

    <div class="col-md-12 px-0">
      <the-table 
        id="rmpi-report"
        :dataItems="computedAnimals"
        :headers="headersForTable"
      />
    </div>

    <button-export
      :print="true"
      @print="PDFPrint"
      v-if="computedAnimals.length"
      :excel="true"
      :headers="excel_fields"
      :data="computedExcel"
      :title="'Relatório de RMPI'"
      @export-pdf="PDFExport"
    />
  </div>
</template>

<script>
import Presentation from "./Presentation";
import ReportFilters from "./ReportFilters";
import TheTable from "@/components/layout/TheTable";
import ButtonExport from "@/components/layout/ButtonExport";
import {mapState, mapActions} from "vuex";
import { exportOfficialTablePdf } from "@/utils/officialPdf";
export default {
  name:"RmpiReport",
  components: {
    Presentation,
    ReportFilters,
    TheTable,
    ButtonExport
  },
  data() {
    return {
      headersForTable:[
        {text:"Código", value:"code"},
        {text:"Animal", value:"animal_name"},
        {text:"OL", value:"ol"},
        {text:"N. Control.", value:"controls"},
        {text:"Dias Lact.", value:"days_lact"},
        {text:"Produção", value:"milk_production"},
        {text:"N. Ord", value:"number_collection"},
        {text:"Prod. Acumulado", value:"milk_acumulate"},
        {text:"Média Diária", value:"average_day"},
        {text:"RA", value:"ra"},
        {text:"Proj. 305 dias", value:"days_305"},
        {text:"Desvio da Média", value:"detor_average"},
      ],
      animalsModal:false,
      serviceModal:{},
      excel_fields:{
        "Total de Animais":"total_animals",
        "Produção Total":"total_production",
        "Média de Produção":"average_production",
        "Código":"code",
        "Animal":"animal_name",
        "OL":"ol",
        "N. Control":"controls",
        "Dias Lact":"days_lact",
        "Produção":"milk_production",
        "N. Ord":"number_collection",
        "Prod. Acumulado":"milk_acumulate",
        "Média Diária":"average_day",
        "RA":"ra",
        "Proj. 305 dias":"days_305",
        "Desvio da Média":"detor_average"
      },
      filter:{}
    }
  },
  computed: {
    ...mapState("creators", ["creators"]),
    ...mapState("service", ["services"]),
    ...mapState("rmpi_report", ["results"]),
    computedAnimals() {
      if(this.results.animals) {
        return this.results.animals.map(e => ({
          ...e,
          animal_name:e.animal.register + " - " + e.animal.name,
          code:e.animal.code
        }));
      } else {
        return [];
      }
    },
    computedExcel() {
      if(this.results.animals) {
        this.computedAnimals.forEach((e, i) => {
          if(i === 0) {
            e.total_animals = this.results.totals.animals
            e.total_production = this.results.totals.milk_production
            e.average_production = this.results.totals.average
          }
        })
        return this.computedAnimals;
      } else {
        return [];
      }
    },
  },
  methods: {
    ...mapActions("creators", ["actionGetCreators"]),
    ...mapActions("service", ["actionGetServices"]),
    ...mapActions("rmpi_report", ["actionGetReports"]),
    async submit(filter) {
      this.filter = filter;
      await this.actionGetReports({service_id:filter.service_id});
    },
    updateFilter(filter) {
      this.filter = filter;
    },
    async PDFExport(print = false) {
      const { date, date_end, person_id } = this.filter;
      const creator = this.creators.find(e => e.id === person_id);
      const totals = this.results.totals || {};
      return exportOfficialTablePdf({
        table: "#rmpi-report", title: "RELATÓRIO R.M.P.I.",
        details: [
          `Período: ${date || "-"} até ${date_end || "-"}    Criador: ${creator?.name || "-"}`,
          `Animais: ${totals.animals || 0}    Produção total: ${totals.milk_production || 0}    Média: ${totals.average || 0}`
        ],
        filename: `relatorio_rmpi_${Date.now()}.pdf`, print
      });
    },
    async PDFPrint() {
      await this.PDFExport(true);
    },
  },
  async mounted() {
    await this.actionGetCreators();
    await this.actionGetServices({summary:true});
  }
}
</script>

<style>

</style>